<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    id?: string;
    value?: string | number | null;
    strong?: boolean;
    tag?: string;
  }>(),
  {
    tag: 'div',
    value: '',
    strong: false,
  },
);

const tagName = computed(() => (props.strong ? 'strong' : props.tag));
const text = computed(() => props.value ?? '');
</script>

<template>
  <component :is="tagName" :id="id" class="form-control-plaintext">
    <slot>{{ text }}</slot>
  </component>
</template>

